import { createI18n } from "vue-i18n";
import en from "./en";
import de from "./de";

const messages = {
  en,
  de,
};

// Load saved language preference from localStorage, default to 'de'
let savedLocale = "de";
try {
  if (typeof window !== "undefined" && window.localStorage) {
    savedLocale = localStorage.getItem("userLanguage") || "de";
  }
} catch (error) {
  console.error("Error accessing localStorage:", error);
}

export default createI18n({
  legacy: false,
  globalInjection: true,
  locale: savedLocale,
  fallbackLocale: "en",
  messages,
});
